import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ComercialModel } from "../../models/comercial/comercial.model";
import { ComercialRepository } from "../../repositories/comercial.repository";

export class DeleteComercialUseCase implements UseCase<{ Id: string}, ComercialModel> {
    constructor(private comercialRepository: ComercialRepository) { }
    execute(
        params: {Id: string},
    ): Observable<ComercialModel> {
        return this.comercialRepository.deleteComercial(params);
    }
}
